/** @format */

import {styled} from '@mui/material/styles';
import {TableCell, TableCellProps} from '@mui/material';

const StyledTableHeadCell = styled((props: TableCellProps) => <TableCell {...props} />)(
  ({theme}) => ({
    borderBottom: 'none',
    fontWeight: 700,
    fontSize: 14,
    color: theme.palette.figma_gray_middle_dark?.main,
    letterSpacing: '0.28px',
    lineHeight: '16px',
    padding: theme.spacing(0, 2),
  }),
);

export {StyledTableHeadCell};
